import directorySeo from "./seo.json";

export function getDirectorySeo(path) {
  return directorySeo[path] || {
    title: "TechniaHQRobot Robotics Directory",
    description: "Find robotics companies, software and components with product descriptions, source links and recorded source-check dates.",
    lastmod: "2026-07-10",
  };
}

export default directorySeo;
